// Temporary workaround handle MVE assignments created before activity selection was released.
export const ACTIVITIES_SELECTION_RELEASE = "2023-05-31T13:00:00Z";
